import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-customs-tarif-menu',
  templateUrl: './customs-tarif-menu.component.html',
  styleUrls: ['./customs-tarif-menu.component.css']
})
export class CustomsTarifMenuComponent implements OnInit {
    customsTarifId;

    public menu?: Menu;

    public customsTarifButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customstariflang', gotoParms: () => this.menu!.customstarif_id ?? '' }
    ];

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.customsTarifId = this.stateService.getStateParams()['customstarif_id'];
    }

    private async loadMenu() {
        if (!!this.customsTarifId) {
            this.menu = (await this.datatask.Post(1726, { customstarif_id: this.customsTarifId }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1729, this.menu))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    customstarif_id: string;
    customstarif_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customsTarifMenu', {
//        templateUrl: 'views/components/views/customsTarifMenu/customsTarifMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'customsTarifMenuService', function ($stateParams, stateService, modalService, translateService, customsTarifMenuService) {
//            const vm = this;
//            let customsTarifId = $stateParams.customstarif_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                customsTarifButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('customstariflang', { customstarif_id: vm.model.menu.customstarif_id }) }
//                ],
//                menu: {},
//                lockedDelete: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadMenu() {
//                vm.model.menu = (await customsTarifMenuService.getCustomsTarifMenu({ customstarif_id: customsTarifId }))[0];
//            }

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    customsTarifMenuService.deleteItem(vm.model.menu).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: (dialogItself) => {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            };

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            }
//        }]
//    });
//})();
